module.exports = __webpack_public_path__ + "img/mobile_map_bogota.df3e8c09.svg";